module.exports = __webpack_public_path__ + "img/companyIntro37.85166ab3.png";